import { render } from "./RecipesListProfile.vue?vue&type=template&id=674960a7"
import script from "./RecipesListProfile.vue?vue&type=script&lang=js"
export * from "./RecipesListProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__